import { useState } from "react";
import { toast } from "sonner";
import { errorMessage } from "../../api/client";
import { tsApi, type MyCorrection } from "../../api/timesheets";
import { Button, TextInput } from "../../components/ui";

export const CATEGORY_LABEL: Record<string, string> = {
  FORGOT_IN: "Forgot to clock in", FORGOT_OUT: "Forgot to clock out", WRONG_TIME: "Wrong time recorded", GPS_PROBLEM: "GPS problem",
  OTHER: "Other", MISSED_IN: "Missed clock-in", MISSED_OUT: "Missed clock-out",
};
const STATUS_LABEL: Record<string, string> = {
  PENDING: "Pending", NEEDS_CLARIFICATION: "Admin needs more info", APPROVED: "Approved", REJECTED: "Rejected", WITHDRAWN: "Withdrawn",
};

export function MyCorrectionItem({ c, onChanged }: { c: MyCorrection; onChanged: () => void }) {
  const [reply, setReply] = useState("");
  const act = async (fn: () => Promise<unknown>, ok: string) => {
    try {
      await fn();
      toast.success(ok);
      setReply("");
      onChanged();
    } catch (e) {
      toast.error(errorMessage(e));
    }
  };
  const open = c.status === "PENDING" || c.status === "NEEDS_CLARIFICATION";
  return (
    <li data-testid={`my-correction-${c.id}`} className="rounded-sm border border-white/10 p-3">
      <p>Correction · {CATEGORY_LABEL[c.category] ?? c.category} · in {c.requested_in_local ?? "—"} · out {c.requested_out_local ?? "—"} · <strong data-testid={`my-correction-status-${c.id}`} className="text-white">{STATUS_LABEL[c.status] ?? c.status}</strong></p>
      {c.note && <p data-testid={`my-correction-note-${c.id}`} className="mt-1 text-zinc-400">Your note: “{c.note}”</p>}
      {c.decision && <p data-testid={`my-correction-decision-${c.id}`} className="mt-1 text-zinc-400">{c.decision.decision === "APPROVED_WITH_CHANGES" ? "Approved with changes" : STATUS_LABEL[c.decision.decision] ?? c.decision.decision} by Admin{c.decision.reason ? ` — “${c.decision.reason}”` : ""}</p>}
      {c.messages.filter((m) => m.kind !== "DECISION").length > 0 && (
        <ul className="mt-2 space-y-1 border-l border-white/10 pl-3" data-testid={`my-correction-thread-${c.id}`}>
          {c.messages.filter((m) => m.kind !== "DECISION").map((m, i) => <li key={i}><span className="font-semibold text-white">{m.from}:</span> {m.text}</li>)}
        </ul>
      )}
      {c.status === "NEEDS_CLARIFICATION" && (
        <div className="mt-2 flex gap-2">
          <TextInput placeholder="Your reply" value={reply} onChange={(e) => setReply(e.target.value)} data-testid={`my-correction-reply-${c.id}`} />
          <Button onClick={() => act(() => tsApi.reply(c.id, reply), "Reply sent")} disabled={!reply.trim()} data-testid={`my-correction-reply-send-${c.id}`}>Reply</Button>
        </div>
      )}
      {open && <button className="mt-2 text-xs text-zinc-400 hover:text-white" onClick={() => act(() => tsApi.withdraw(c.id), "Request withdrawn")} data-testid={`my-correction-withdraw-${c.id}`}>Withdraw request</button>}
    </li>
  );
}
